import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ViewSettingsService {
    _showOnlyRequiredFields: boolean = true;

    private readonly showOnlyRequiredFieldsSubject = new BehaviorSubject<boolean>(this._showOnlyRequiredFields);
    readonly showOnlyRequiredFields$ = this.showOnlyRequiredFieldsSubject.asObservable().pipe(distinctUntilChanged());

    constructor() {}

    get showOnlyRequiredFields(): boolean {
        return this._showOnlyRequiredFields;
    }

    set showOnlyRequiredFields(value: boolean) {
        this._showOnlyRequiredFields = value;
        this.showOnlyRequiredFieldsSubject.next(value);
    }
}
